import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d476588&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d476588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d476588')) {
      api.createRecord('6d476588', component.options)
    } else {
      api.reload('6d476588', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d476588&scoped=true", function () {
      api.rerender('6d476588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/deliverGoods/index.vue"
export default component.exports